import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { handleError } from "src/Common/function";
import WOService from "src/Services/API/wo.service";
import UserService from "src/Services/API/user.service";

const WoDropdown = ({ selectedValue, onSelect, placeholder = "Select" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [options, setOptions] = useState([]);

  const selectedLabel =
    selectedValue?.number !== null &&
      selectedValue?.number !== undefined &&
      String(selectedValue?.number) !== ""
      ? `#${selectedValue.number}${selectedValue.description ? ` - ${selectedValue.description}` : ""}`
      : placeholder;

  const fetchWoNumbers = async (value) => {
    try {
      const user = UserService.getCurrentUser();
      const response = await WOService.getAllWorkOrders(
        user?.id,
        value || "",
        0,
        null,
        null,
        0
      );
      if (response.status === 200) {
        const woOptions = (response.data?.orders || []).map((order) => ({
          id: order.id,
          number: order.number,
          description: order.description || "",
        }));
        setOptions(woOptions);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const handleKeywordChange = (value) => {
    setKeyword(value);
    fetchWoNumbers(value);
  };

  const handleToggle = () => {
    const next = !isOpen;
    setIsOpen(next);
    if (next) {
      fetchWoNumbers(keyword);
    }
  };

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <div className="relative w-full">
        <div
          onClick={handleToggle}
          className="w-full flex items-center h-[30px] justify-between px-4 py-2 border rounded-[6px] text-gray-800 focus:outline-none focus:border-blue-500 cursor-pointer"
        >
          <span className="font-OpenSansRegular text-[12px] text-titleColor truncate">{selectedLabel}</span>
          <FiChevronDown className="ml-2" size={15} />
        </div>
        {isOpen && (
          <ul className="absolute z-10 mt-2 w-full bg-white border rounded-md shadow-lg max-h-[300px] overflow-y-auto">
            <div className="w-full h-[30px] border-solid border-b-[1px] flex items-center justify-center px-[15px]">
              <input
                value={keyword}
                type="text"
                onChange={(e) => handleKeywordChange(e.target.value)}
                className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                placeholder="Search by WO# or description..."
              />
            </div>
            {options.length === 0 && (
              <li className="px-4 py-2 font-OpenSansRegular text-[12px] text-subTitleColor">
                No work orders found
              </li>
            )}
            {options.map((option, index) => (
              <li
                key={`${option.id}-${index}`}
                onClick={() => {
                  onSelect(option);
                  setIsOpen(false);
                }}
                className="px-4 py-2 cursor-pointer hover:bg-gray-200 font-OpenSansRegular text-[12px]"
              >
                {`#${option.number}${option.description ? ` - ${option.description}` : ""}`}
              </li>
            ))}
          </ul>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default WoDropdown;
